<template>
    <div class="container">
        <div class="main">
            <div class="content">
                <div class="box-f">
                    <div class="title" v-if="item.QuestionName">{{item.QuestionName}}</div>
                    <div>
                        <span>{{item.addTime | datefmt('yyyy-MM-DD')}}</span> ·
                        <span>{{item.answerCount || 0}}个回答</span>
                    </div>
                    <div class="line"></div>
                    <userInfo :item="item" :isShowFollow="false" />
                    <div v-if="item.postType==1||item.postType==2||item.postType==3||item.postType==4||item.postType==5" class="article-desc editor-content-view mar20">
                        <a href="javascript:;" class="talk-name" v-if="item.talkName">{{ `#${item.talkName}#` }}</a>
                        {{item.content || item.postDescribe}}
                    </div>
                    <div v-else class="editor-content-view mar20">
                        <div id="editor-content-view" v-html="item.content">
                        </div>
                    </div>
                    <div v-if="(item.postType==1||item.postType==3||item.postType==4||item.postType==5)&&item.attachList&&item.attachList.length>0">
                        <div class="img-wrap">
                            <div v-for="(itemImg,index) in item.attachList" :key="index">
                                <img :src="itemImg.fileUrl" />
                            </div>
                        </div>
                    </div>
                    <div v-if="item.postType==2&&item.attachList&&item.attachList.length>0">
                        <!-- <div class="video-wrap" v-for="(videoItem,index) in item.attachList" :key="index">
                            <video :poster="posterUrl" controls :src="videoItem.fileUrl">
                                您的浏览器不支持 video 标签。
                            </video>
                        </div> -->
                        <div class="video-wrap">
                            <video :poster="item.coverUrl" controls :src="item.picUrl">
                                您的浏览器不支持 video 标签。
                            </video>
                        </div>
                    </div>
                    <div class="article-card-bottom">
                        <div class="bottom-l">
                            <div class="article-viewcnt">
                                <span>{{item.updateTime | datefmt('yyyy-MM-DD')}}</span>
                                <span>浏览 {{item.viewNum || 0}}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="comment-wrap box-f mt-2" v-if="commentList.length>0">
                    <div class="ub ub-pj">
                        <div>
                            <div class="comment-title">
                                全部评论 <span>{{item.discussNum}}</span>
                            </div>
                        </div>
                        <div class="questions-wrap">
                            <span :class="[sortType==2?'active':'']" @click="toQuestionSort(2)">热门</span>
                            <span :class="[sortType==1?'active':'']" @click="toQuestionSort(1)">最新</span>
                        </div>
                    </div>
                    <div v-for="(item,index) in commentList" :key="index">
                        <commentList :className="index == commentList.length-1 ? 'last' :''" :item="item" :isShow="true" :type="type" @toComment="toCommentReply" @getComment="getCommentList"/>
                        <div v-if="item.childList" class="comment-reply">
                            <div v-for="(itemChild,_index) in item.childList" :key="_index">
                                <commentList :className="index == commentList.length-1 ? 'last' :''" :item="itemChild" :isShow="true"  @toComment="toCommentReply" @getComment="getCommentList" />
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="id" class="comment-fixed" v-sticky-bottom="{ sentinel: '.comment-wrap' }">
                    <div class="comment-input" @click="toPublic">
                        <svg class="comment-icon" viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>
                        <span class="placeholder-text">{{ userId ? '说说你的想法...' : '登录后才可评论' }}</span>
                    </div>
                    <div class="right-operate">
                    <div class="article-num" @click.stop="toPublic">
                        <svg class="icon" viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>
                        <span>{{item.discussNum}}</span>
                    </div>
                </div>
                </div>
                <div class="comment-placeholder"></div>
            </div>
            <div class="aside">
                <userAside :id="item.answerUserId" />
                <asideNews />
                <asideCircle />
            </div>
        </div>
        <el-dialog :title="type == 'QUESTION' ? '发表评论' : '发表评论'" :visible.sync="publicDialogVisible" :before-close="handleClose" top="32vh" width="500px">
            <div class="public-dialog">
                <textarea v-model="commentCnt" :placeholder="placeholderText"></textarea>
                <div class="dialog-btn">
                    <span class="public-btn" @click="toComment">发布</span>
                </div>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import asideNews from '@/components/aside/news'
import asideCircle from '@/components/aside/recommendCircle'
import userInfo from '@/components/userinfo/userinfo'
import commentList from '@/components/circle/commentList'
import userAside from '@/components/aside/userAside'
import qs from 'qs'
import { post, ajaxParam } from '@/units/request.js'
import '@/assets/css/rich.less'
export default {
    name: 'detail',
    components: {
        asideNews,
        asideCircle,
        userInfo,
        commentList,
        userAside
    },
    data() {
        return {
            datapicker: '',
            isLogin: false,
            publicDialogVisible: false,
            id: '',
            userId: '',
            item: {},
            commentCnt: '',
            parentDiscussId: 0,
            pageSize: 10,
            pageNum: 1,
            commentList: [],
            totalComment: 0,
            placeholderText: '友善评论,共建和谐社区',
            percentage: '',
            percentage2: '',
            activefeedback: 1,
            type: '',
            sortType: 1, // 1最新 2热门
        }
    },
    mounted() {
        this.userId = localStorage.getItem('userId') || ''
        this.id = this.$route.query.id
        this.type = this.$route.query.type
        this.getDetailById(true)
        console.log('item:',this.item)
    },
    watch: {
        $route(to) {
            this.id = to.query.id
            this.getDetailById(true)
        }
    },
    beforeDestroy() {
        localStorage.removeItem('previewInfo')
    },
    methods: {
        toCommentReply(e) {
            if (!this.userId) {
                this.$router.push({
                    path: '/login'
                })
                return
            }
            this.publicDialogVisible = true
            console.log(e)
            this.placeholderText = '正在回复 ' + e.item.discussUserName
            this.parentDiscussId = e.item.id

        },
        //发表评论
        async toComment() {
            let param = {
                postId: this.item.id,
                discussUserId: this.userId,
                content: this.commentCnt,
                parentDiscussId: this.parentDiscussId
            }
            console.log(param)
            ajaxParam(param)
            const res = await post('v1/circle/discussAnswer', qs.stringify(param))
            if (res.data.code == 200) {
                this.$message.success(res.data.msg||'操作成功!')
                this.handleClose()
                this.getCommentList()
                this.getDetailById(true)
            } else {
                this.$message.error(res.data.msg)
            }
        },
        //获取评论列表
        async getCommentList() {
            let param = {
                postId: this.item.id,
                userId: this.userId,
                pageNum: this.pageNum,
                pageSize: this.pageSize,
                discussType:2
            }
            ajaxParam(param)
            let res = null
            res = await post('v1/circle/discussList', qs.stringify(param))
            if (res.data.code == 200) {
                this.commentList = res.data.list
                this.totalComment = res.data.total
                console.log(this.commentList, 'this.commentListthis.commentList')
            } else {
                this.$message.error(res.data.msg)
            }
        },
        toQuestionSort(e){
            this.sortType = e
            this.commentList = []
            this.pageNum = 1
            this.getCommentList()
        },
        //根据id获取详情
        async getDetailById(isTrue) {
            if (this.id) {
                let param = {
                    answerId: this.id,
                    userId: this.userId
                }
                ajaxParam(param)
                const res = await post('v1/circle/answerInfo', qs.stringify(param))
                if (res.data.code == 200) {
                    this.$set(this, 'item', res.data.entity)
                    if (isTrue) {
                        this.getCommentList()
                    }
                    if(this.type == 'SUGGEST'){
                        if(this.item.wantTotalNum == 0) {
                            this.percentage =0
                            this.percentage2 =0
                        } else {
                            this.percentage = (Number(this.item.suggestWantNum)/Number(this.item.wantTotalNum)) * 100
                            this.percentage2 = (Number(this.item.suggestNowantNum)/Number(this.item.wantTotalNum)) * 100
                        }
                    }
                    this.activefeedback = this.item.feedbackStatus ? this.item.feedbackStatus : 0
                    const _item = { ...res.data.entity }
                    if (_item.talkName) {
                        this.$nextTick(() => {
                            const contentBox = document.getElementById('editor-content-view')
                            if (contentBox && contentBox.childNodes[0]) {
                                const newElement = document.createElement('a')
                                newElement.href = 'javascript:;'
                                newElement.setAttribute('class', 'talk-name')
                                newElement.innerText = `#${_item.talkName}#`
                                contentBox.childNodes[0].insertBefore(newElement, contentBox.childNodes[0].firstChild)
                            }
                        })
                    }
                } else {
                    this.$message.error(res.data.msg)
                }
            } else {
                const userinfo = localStorage.getItem('user') || '{}'
                const previewInfo = localStorage.getItem('previewInfo') || '{}'
                const _userinfo = JSON.parse(userinfo)
                _userinfo.userId = _userinfo.id
                const _previewInfo = JSON.parse(previewInfo)
                console.log(_userinfo, '_userinfo')
                const _item = { ..._userinfo, ..._previewInfo }
                _item.addTime = new Date().getTime()
                this.$set(this, 'item', _item)
                if (_item.talkName) {
                    this.$nextTick(() => {
                        const contentBox = document.getElementById('editor-content-view')
                        if (contentBox && contentBox.childNodes[0]) {
                            const newElement = document.createElement('a')
                            newElement.href = 'javascript:;'
                            newElement.setAttribute('class', 'talk-name')
                            newElement.innerText = `#${_item.talkName}#`
                            contentBox.childNodes[0].insertBefore(newElement, contentBox.childNodes[0].firstChild)
                        }
                    })
                }

            }

        },
        toPublic() {
            if (!this.userId) {
                this.$router.push({
                    path: '/login'
                })
                return
            }
            this.publicDialogVisible = true
        },
        //点赞 取消点赞
        async isLikeOrCancel(item) {
            if (!this.userId) {
                this.$router.push({
                    path: '/login'
                })
                return
            }
            let param = {
                userId: this.userId,
                postId: item.id,
                flag: item.isLike == 1 ? 0 : 1
            }
            ajaxParam(param)
            const res = await post('v1/circle/answerLike', qs.stringify(param))
            if (res.data.code == 200) {
                if (item.isLike == 1) {
                    this.$message.success('取消点赞成功！')
                    item.praiseNum--
                    this.getCommentList()
                    this.getDetailById(true)
                } else {
                    this.$message.success('点赞成功！')
                    item.praiseNum++
                    this.getCommentList()
                    this.getDetailById(true)
                }
                item.isLike = item.isLike == 1 ? 0 : 1

            } else {
                this.$message.error(res.data.msg)
            }
        },
        handleClose() {
            this.publicDialogVisible = false
            this.commentCnt = ''
            this.parentDiscussId = 0
            this.placeholderText = '友善评论,共建和谐社区'
        },
    }
}
</script>
<style lang="less" scoped>
.mar20 {
    margin-top: 12px;
}

.article-tags {
    display: flex;
    // border: 1px solid var(--color-border);
    margin-right: 15px;
    padding: 5px;

    // border-radius: 14px;
    .tags-icon {
        // width: 18px;
        // height: 18px;
        margin-right: 4px;
        background: #DD0515;
        border-radius: 14px;
        color: #fff;
        line-height: 18px;
        text-align: center;
    }

    .tags-name {
        font-size: 12px;
        color: var(--color-text);
    }
}
.line{
    height: 1px;
    background: var(--color-border);
    margin: 20px 0;
}
.main {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    width: 1180px;
    margin: 20px auto;

    .content {
        flex: 1;
        .box-f{
            background: #fff;
            padding: 20px 30px 60px;
            border-radius: 10px;
            position: relative;
            font-size: 16px;
        }
        

        .title {
            margin: 20px 0 12px;
            font-size: 26px;
            line-height: 1.4;
            word-break: break-word;
            overflow-wrap: anywhere;
        }

        .article-desc {
            line-height: 22px;
            word-break: break-word;
            overflow-wrap: anywhere;
        }

        /deep/ img {
            max-width: 80% !important;
            max-height: 100% !important;
            object-fit: cover;
            display: flex;
            flex-wrap: wrap;
            margin-right: 10px;
            margin-top: 10px;
            border-radius: 10px;
        }

        img {
            max-width: 80% !important;
            max-height: 100% !important;
            object-fit: cover;
            display: flex;
            flex-wrap: wrap;
            margin-right: 10px;
            margin-top: 10px;
            border-radius: 10px;
        }

        .img-wrap {
            display: flex;
            flex-wrap: wrap;
        }

        .video-wrap {
            display: flex;
            width: 98%;
            margin-top: 20px;

            video {
            max-width: 100%;
            max-height: 600px;
            }
        }

        .article-img {
            margin-top: 8px;
        }

        .article-card-bottom {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 12px 0;

            .bottom-l {
                display: flex;
                align-items: center;

                .article-viewcnt span {
                    margin-right: 15px;
                    color: var(--color-text-opacity);
                }
            }
        }

        .comment-title {
            padding: 10px 0 20px;
            font-weight: bold;
        }

        .comment-reply {
            // margin-top: 6px;
            // padding-left: 30px;
        }

        .comment-fixed {
            display: flex;
            justify-content: space-between;
            align-items: center;
            position: relative;
            z-index: 1001;
            width: 100%;
            bottom: auto;
            left: auto;
            margin-top: 20px;
            height: 68px;
            padding: 12px 30px;
            box-sizing: border-box;
            border-radius: 16px 16px 0 0;
            border: 1px solid rgba(50, 50, 51, .06);
            border-bottom: 0;
            box-shadow: 0 -8px 30px rgba(0, 0, 0, 0.06);
            background: #fff;

            &.is-fixed {
                position: fixed;
                bottom: 0;
                border-radius: 16px 16px 0 0;
            }

            &.is-static {
                position: relative;
                width: 100%;
                bottom: auto;
                left: auto;
                border-radius: 16px;
                box-shadow: 0 -8px 30px rgba(0, 0, 0, 0.06);
            }

            .comment-input {
                display: flex;
                align-items: center;
                height: 44px;
                padding: 0 16px;
                border-radius: 24px;
                background: #F5F6F8;
                border: 1px solid transparent;
                flex: 1;
                cursor: pointer;
                min-width: 0;
                transition: background 0.2s ease, border-color 0.2s ease;

                &:hover {
                    border-color: rgba(50, 50, 51, .12);
                    background: #F0F1F4;
                }

                .comment-icon {
                    width: 18px;
                    height: 18px;
                    margin-right: 8px;
                    flex-shrink: 0;
                    color: var(--color-text-opacity);
                    opacity: 0.6;
                }

                .placeholder-text {
                    font-size: 14px;
                    color: var(--color-text-opacity);
                    opacity: 0.7;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }
            }

            .right-operate {
                display: flex;
                align-items: center;
                gap: 20px;
                flex-shrink: 0;
                margin-left: 16px;

                .article-num {
                    display: flex;
                    align-items: center;
                    gap: 4px;
                    color: var(--color-text-opacity);
                    cursor: pointer;
                    flex-shrink: 0;
                    transition: opacity 0.2s ease;

                    &:hover {
                        opacity: 0.85;
                    }

                    .icon {
                        width: 18px;
                        height: 18px;
                        flex-shrink: 0;
                        opacity: 0.6;
                    }

                    span {
                        font-size: 12px;
                    }

                    &.active {
                        color: #DD0515;
                        .icon {
                            opacity: 1;
                            fill: #DD0515;
                            stroke: #DD0515;
                        }
                    }
                }
            }
        }
        .comment-placeholder {
            height: 68px;
            margin-top: 20px;
            display: none;
        }
        .comment-fixed.is-fixed + .comment-placeholder {
            display: block;
        }
        .question-fixed{
            position: fixed;
            z-index: 1001;
            width: 200px;
            margin: auto;
            text-align: center;
            bottom: 20px;
            left: 40%;
            // right: 0;
            height: 40px;
            line-height: 40px;
            border-radius: 26px;
            color: #fff;
            box-shadow: 0px -2px 4px 0px rgba(0, 0, 0, 0.12);
            background: red;
            cursor: pointer;
        }
    }

    .aside {
        width: 300px;
        margin-left: 20px;
    }
    .article-img {
        margin-top: 8px;
    }

    .suggest-content{
        width: 100%;
        display: flex;
        margin-top: 20px;
        justify-content: space-around;
        .suggest-text,.suggest-no{
            width:262px;
            height: 38px;
            text-align: center;
            line-height: 38px;
            border: 1px solid #c6bfbf;
            color: #c6bfbf;
            border-radius: 10px;
        }
        .suggest-text{
            border: 1px solid #eb7979;
            color: #eb7979;
        }
        .suggest-progress{
            width: 60%;
            border: none;
        }
    }
    .flex-set{
        flex-direction: column;
        align-items: center;
        .suggest-result{
            width: 60%;
            margin-top: 10px;
            display: flex;
            justify-content: space-between;
            .want{
                color: #d01c1d;
            }
            .nowant{    
                color: #6575b4;
            }
        }
    }

}

/deep/ .el-dialog {
    border-radius: 10px;
}

.public-dialog {
    display: flex;
    flex-direction: column;

    textarea {
        height: 100px;
        background: #f6f7f8;
        padding: 10px;
        border-radius: 10px;
        border: none;
        line-height: 24px;
        box-sizing: border-box;
    }

    .dialog-btn {
        display: flex;
        justify-content: flex-end;

        .public-btn {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 68px;
            height: 30px;
            margin-top: 20px;
            background: #DD0515;
            border-radius: 16px;
            color: #fff;
            cursor: pointer;
        }
    }

}

:deep .el-dialog__body {
    padding-top: 10px;
}
.suggest-progress{
    :deep .el-progress-bar__outer{
        background: #6575b4;
    }
}
.article-num {
    display: flex;
    align-items: center;
    margin-right: 25px;

    img {
        width: 18px;
        height: 18px;
        margin-right: 4px;
    }

    span {
        opacity: .6;
        font-size: 12px;
    }
    .plus-one{
        width: 14px;
        height: 14px;
        border-radius: 50%;
        border: 1px solid #666;
        text-align: center;
        line-height: 12px;
        span{
            font-size: 10px;
        }
    }
    &.active{
        color: #DD0515;
        .plus-one{
            border-color: #DD0515;
            color: #DD0515;
        }
    }
    
}
.box-feedback{
    padding: 30px;
    background: #000;
    color: #efefef;
    :deep .el-step {
    /* 步骤条连接线颜色 */
    .el-step__line {
        background-color: #999 !important;
    }

    /* 步骤图标和文字颜色（未完成状态） */
    .el-step__head {
        color: #999;
        border-color: #999;
    }

    /* 当前进行中的步骤颜色 */
    .el-step__head.is-process {
        color: #999 !important;
        border-color: #999 !important;
    }

    /* 已完成步骤的颜色 */
    .el-step__head.is-success {
        color: #d01c1d !important;
        border-color: #d01c1d !important;
    }

    /* 步骤标题颜色 */
    .el-step__title {
        color: #666;
        &.is-process {
        color: #999 !important;
        }
        &.is-success {
        color: #d01c1d !important;
        }
    }
    }
}
.questions-wrap{
    display: flex;
    align-items: center;
    width: 198px;
    height: 32px;
    background: #c4c4c4;
    border-radius: 4px;
    justify-content: space-around;
    z-index: 20;
    color: #fff;
    span{
        display: block;
        width: 100%;
        height: 32px;
        border-radius: 4px;
        text-align: center;
        line-height: 32px;
        cursor: pointer;
        font-size: 12px;
    }
    span.active{
        background: #f04444;
    }
}
</style>